<template>
  <div>
    <v-row >
      <v-col md="4" v-for="(card, index) in cards" :key="index">
        <div v-show="lista_permissoes_filial[card.permissao]" >
          <a @click="trocar_pagina(card.rota)" :class="card.cardClass">
            <div class="card-body">
              <div class="d-flex align-items-cente">
                <div class="d-flex flex-column">
                  <a @click="trocar_pagina(card.rota)" :class="card.linkClass">
                    {{ card.titulo }} {{ card.contador }}
                  </a>
                  <div class="text-dark-75">{{ card.descricao }}</div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </v-col>
    </v-row>
      <v-row>
        <v-card elevation="15" class="p-3">
          <div class="row">
            <div class="col-md-9 mb-3">
              <!-- <label class="col-md-12">Eventos:*</label> -->
              <treeselect :multiple="false" :options="lista_eventos" placeholder="Selecione o evento..."
                v-model="eventos_id" @input="listar_pdv_ingressos_grafico" />
            </div>
            <div class="col-md-3 text-end">
              <v-btn color="primary" depressed elevation="2" outlined @click="rel()">Relatorio</v-btn>
            </div>
          </div>
        </v-card>
      </v-row>
    <graficos v-if="sh" :id_evento="eventos_id"></graficos>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import graficos from "@/view/components/dashbords/grafico.vue";
export default {
  name: "dashboard",
  components: { graficos },
  data() {
    return {
      eventos_id: null,
      sh: false,
      tabIndex: 0,
      tabIndex2: 0
    };
  },
  mounted() {
    this.listar_eventos();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
    this.$store.dispatch("configUsuarios/count");
  },
  computed: {
    count_cliente() {
      return this.$store.state.configUsuarios.count_cliente;
    },
    lista_pdv_ingressos_grafico() {
      return this.$store.state.pdvsEventoIngresso
        .lista_pdvs_evento_ingressos_graficos;
    },
    lista_permissoes_filial() {
      return this.$store.state.sistema.lista_permissoes_filial;
    },
    lista_eventos() {
      return this.$store.state.evento.lista_eventos.map((cat) => ({
        id: cat.id,
        label: cat.nome_evento + " - " + cat.id,
      }));
    },
    cards() {
      return [
        {
          key: 'usuarios',
          permissao: 'ra_Usuario',
          rota: 'gerenFuncionarios',
          cardClass: 'card card-custom wave wave-animate-fast wave-success',
          iconClass: 'svg-icon svg-icon-success svg-icon-4x',
          linkClass: 'text-dark text-hover-danger font-weight-bold font-size-h4 mb-3',
          titulo: 'Usuarios',
          contador: this.count_cliente.usucount,
          descricao: 'Aqui pode visualizar Funcionarios'
        },
        {
          key: 'eventos',
          permissao: 'ra_Evento',
          rota: 'evento',
          cardClass: 'card card-custom wave wave-animate-fast wave-primary',
          iconClass: 'svg-icon svg-icon-success svg-icon-4x',
          linkClass: 'text-dark text-hover-danger font-weight-bold font-size-h4 mb-3',
          titulo: 'Eventos',
          contador: this.count_cliente.eventos_ativos,
          descricao: 'Acessar Eventos'
        }
      ];
    }
  },
  methods: {
    listar_eventos() {
      this.$store.dispatch("evento/listar_eventos");
    },
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    trocar_pagina(rota) {
      this.$router.push({ name: rota });
    },
    async listar_pdv_ingressos_grafico() {
      this.sh = false;
      await this.$store.dispatch(
        "pdvsEventoIngresso/listar_pdv_ingressos_grafico",
        this.eventos_id
      );
      this.sh = true;
    },
    rel() {
      if (!this.eventos_id) {
        this.alertMessage("warning", "Seleciona um Evento");
      } else {
        window.open(
          process.env.VUE_APP_API_URL +
          "pdvs_ingresso/relatorio/" +
          this.eventos_id,
          "_blank"
        );
      }
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }
      event.target.classList.add("active");
      return parseInt(event.target.getAttribute("data-tab"));
    },
    alertMessage(type, message) {
      // Implemente aqui o método de alerta conforme seu sistema
      alert(`${type}: ${message}`);
    }
  }
};
</script>
